import {
    useCallback, useMemo, useState,
} from 'react'
import AdditionalFeesGrid
    from 'app/PoC/DataGridDemoPages/ContractBasisDemo/ContractBasisDemoCreateQuote/steps/FinalSelectionStep/AdditionalFeesGrid'
import LaneFeesGrid
    from 'app/PoC/DataGridDemoPages/ContractBasisDemo/ContractBasisDemoCreateQuote/steps/FinalSelectionStep/LaneFeesGrid'
import {
    State,
} from 'app/PoC/DataGridDemoPages/ContractBasisDemo/ContractBasisDemoCreateQuote/useContractBasisCreateQuoteReducer'
import idConvertions from 'app/Apps/Pricing/ContractBasis/utils/idConvertions'
import Button from 'app/shared-components/Button'
import useMarginStyles from 'app/tss/margin.styles'
import useContractBasisCreateQuoteContext from '../../ContractBasisCreateQuoteContext'

export default function FinalSelectionStep({
    classes,
    renderActions,
    state,
}: Readonly<{
    classes: Record<string, string>,
    renderActions: (params: any) => JSX.Element,
    state: State
}>) {
    const {
        setActiveStep,
        quoteId,
    } = useContractBasisCreateQuoteContext()
    const {
        classes: marginClasses,
    } = useMarginStyles({
        bottom: 2,
    })

    const {
        previewData: {
            additionalFeesTableRows,
            lanesTableRows,
            laneQuoteViewType,
        },
        laneFeesSelectedRows,
        additionFeesSelectedRows,
        additionalFee,
        filtersState,
        contactsSelection,
        laneGroups,
    } = state

    const [
        laneFeesSelected,
        setLaneFeesSelected,
    ] = useState(state.laneFeesSelectedRows)

    const [
        additionalFeesSelected,
        setAdditionalFeesSelected,
    ] = useState(state.additionFeesSelectedRows)

    const handleAdditionalFeesOnSelectedRow = useCallback((ids: Set<number>) => {
        setAdditionalFeesSelected(Array.from(ids))
    }, [])

    const handleLaneFeesOnSelectedRow = useCallback((ids: Set<string>) => {
        setLaneFeesSelected(Array.from(ids))
    }, [])

    const params = useMemo(() => {
        const {
            selectedAirports,
            selectedLaneFeesStatuses,
            selectedCustomerExecution,
            exactDates,
            laneFeeValidFrom,
            laneFeeValidTo,
            selectedLaneStatus,
            isCustomerQuotation,
            allowDuplication,
            comment,
        } = filtersState

        return {
            additionalFees: additionalFee,
            laneGroups,
            selectedAirports: selectedAirports?.map(idConvertions),
            selectedLaneFeesStatuses,
            selectedCustomerExecution: selectedCustomerExecution && {
                id: selectedCustomerExecution,
            },
            exactDates,
            laneFeeValidFrom,
            laneFeeValidTo,
            selectedLaneStatus,
            isCustomerQuotation,
            allowDuplication,
            skyCellContact: contactsSelection?.skyCellContact,
            customerContact: contactsSelection?.customerExecutionContact
                || contactsSelection?.customerQuotationContact,
            comment,
            quoteId,
            laneQuoteViewType,
            selectedLaneLaneFeesPairs: (laneFeesSelected || []).map((tempId: string) => {
                const [
                    laneNumber,
                    laneFeesNumber,
                ] = tempId.split('.')

                return {
                    laneNumber,
                    laneFeesNumber,
                }
            }),
            selectedAdditionalFeesFees: additionalFeesSelected,
        }
    }, [
        additionalFee,
        additionalFeesSelected,
        contactsSelection?.customerExecutionContact,
        contactsSelection?.customerQuotationContact,
        contactsSelection?.skyCellContact,
        filtersState,
        laneFeesSelected,
        laneGroups,
        laneQuoteViewType,
        quoteId,
    ])

    return (
        <>
            <div className={marginClasses.margin}>
                <LaneFeesGrid
                    rows={lanesTableRows}
                    defaultSelected={laneFeesSelectedRows}
                    handleSelect={handleLaneFeesOnSelectedRow}
                    classes={classes}
                />
            </div>
            <div>
                <AdditionalFeesGrid
                    rows={additionalFeesTableRows}
                    defaultSelected={additionFeesSelectedRows}
                    handleSelect={handleAdditionalFeesOnSelectedRow}
                    classes={classes}
                />
            </div>
            <div>
                <div className={classes.doubleButtons}>
                    {renderActions(params)}
                    <Button
                        label="Back"
                        secondary
                        onClick={() => {
                            setActiveStep(1)
                        }}
                        className={classes.lastButton}
                    />
                </div>
            </div>
        </>
    )
}
